// D:\VEDITOR\VEDITOR\client\src\components\ThankYouPage.jsx
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast"; // Import Toaster if you want to display toasts
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ThankYou.css";
import "font-awesome/css/font-awesome.min.css";
import {
  faStar,
  faPaperPlane,
  faHome,
  faCode,
  faSmile,
  faFrown,
  faMeh,
  faUser,
  faEnvelope,
  faBriefcase,
  faCheck,
  faShieldAlt,
  faLock,
  faEye,
  faEyeSlash,
  faEdit,
  faCalendar,
  faTimes,
  faShield,
  faFileContract,
  faLock as faPrivacyLock,
  faDatabase,
  faUserShield,
  faInfoCircle,
  faTimesCircle,
  faRocket,
  faHeart,
  faGift,
  faMagic,
} from "@fortawesome/free-solid-svg-icons";

const ThankYouPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { username = "Guest", roomId = "N/A" } = location.state || {};
  // Feedback states
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [emotion, setEmotion] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // User registration states
  const [showNameForm, setShowNameForm] = useState(false);
  const [userRealName, setUserRealName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPosition, setUserPosition] = useState("");
  const [userSessionId, setUserSessionId] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);

  // Privacy Policy state
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  // Animation states
  const [animateStars, setAnimateStars] = useState(false);
  const [confettiActive, setConfettiActive] = useState(false);

  // Check for existing session on component mount
  useEffect(() => {
    const savedSession = localStorage.getItem("veditor_user_session");
    const savedName = localStorage.getItem("veditor_user_name");
    const savedPrivacy = localStorage.getItem("veditor_privacy_accepted");

    if (savedSession && savedName) {
      setUserSessionId(savedSession);
      setUserRealName(savedName);
      setIsRegistered(true);
    }

    if (savedPrivacy === "true") {
      setPrivacyAccepted(true);
    }

    // Check if this is a return visit
    const hasVisitedBefore = localStorage.getItem("veditor_has_visited");
    if (!hasVisitedBefore) {
      localStorage.setItem("veditor_has_visited", "true");
    }

    // Start star animation
    setTimeout(() => setAnimateStars(true), 500);

    // Trigger confetti on successful submission
  }, []);

  // Trigger confetti effect
  const triggerConfetti = () => {
    setConfettiActive(true);
    setTimeout(() => setConfettiActive(false), 3000);
  };

  // Navigate to Intro page
  const goToIntroPage = () => {
    navigate("/intro");
  };

  // Accept Privacy Policy
  const acceptPrivacyPolicy = () => {
    setPrivacyAccepted(true);
    localStorage.setItem("veditor_privacy_accepted", "true");
    toast.success("Privacy Policy accepted. Thank you!");
    setAnimateStars(true);
  };

  // Register user (collect name)
  const registerUser = async () => {
    if (!userRealName.trim()) {
      toast.error("Please enter your name");
      return;
    }

    if (!privacyAccepted) {
      toast.error("Please accept the Privacy Policy first");
      setShowPrivacyPolicy(true);
      return;
    }

          if (userEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail)) {
  toast.error('Invalid email address');
  return;
}

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/save_feedback.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "register_user",
            user_real_name: userRealName,
            user_email: userEmail,
            user_position: userPosition || "Developer",
            privacy_accepted: true,
          }),
        },
      );



      const result = await response.json();

      if (result.success) {
        setUserSessionId(result.user_session_id);
        setIsRegistered(true);
        setShowNameForm(false);

        // Save to localStorage for future visits
        localStorage.setItem("veditor_user_session", result.user_session_id);
        localStorage.setItem("veditor_user_name", userRealName);

        toast.success(`✨ Welcome ${result.user.name}! You're amazing! ✨`);
      } else {
        toast.error(result.error || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error("Connection error");
    }

    finally {
  setIsSubmitting(false); // ✅ ALWAYS runs
}
  };

  // Submit feedback
  const handleSubmitFeedback = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!privacyAccepted) {
      toast.error("Please accept the Privacy Policy");
      setShowPrivacyPolicy(true);
      return;
    }

    if (rating === 0) {
      toast.error("Please select a rating");
      return;
    }

    if (userEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail)) {
    toast.error("Invalid email address");
    return;
  }

    // Check if user is registered
    // Allow anonymous, but warn
    if (!isRegistered) {
      toast("Submitting anonymously", {
        icon: "👤",
        style: { background: "#667eea", color: "white" },
      });
    }


    const feedbackData = {
      submitting_feedback: true,
      username,
      roomId,
      rating,
      emotion,
      feedback,
      user_real_name: userRealName,
      user_email: userEmail,
      user_session_id: userSessionId,
      timestamp: new Date().toISOString(),
      privacy_accepted: privacyAccepted,
    };
  setIsSubmitting(true); // ✅ ADD HERE

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/save_feedback.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(feedbackData),
        },
      );

      const result = await response.json();

      if (result.success) {
        triggerConfetti();
        toast.success(
          `🎉 Thank you ${result.user_name}! Your feedback creates magic! 🎉`,
        );

        // Save to localStorage as backup
        const existingFeedback =
          JSON.parse(localStorage.getItem("veditor_feedback")) || [];
        existingFeedback.push(feedbackData);

        // ADD THIS 👇
        if (existingFeedback.length > 20) {
          existingFeedback.shift();
        }

        localStorage.setItem(
          "veditor_feedback",
          JSON.stringify(existingFeedback),
        );

        setSubmitted(true);
      } else if (result.requires_name || result.requires_registration) {
        setShowNameForm(true);
        // FIXED: Use toast with custom style
        toast(result.message || "Please register your name", {
          icon: "👤",
          style: {
            background: "#667eea",
            color: "white",
          },
        });
      } else {
        toast.error(result.error || "Failed to submit feedback");
      }
    } catch (error) {
      console.error("API Error:", error);

      // Fallback to localStorage
      const existingFeedback =
        JSON.parse(localStorage.getItem("veditor_feedback")) || [];
      existingFeedback.push(feedbackData);

      // ADD THIS 👇
      if (existingFeedback.length > 20) {
        existingFeedback.shift();
      }

      localStorage.setItem(
        "veditor_feedback",
        JSON.stringify(existingFeedback),
      );
      toast.success("Feedback saved locally!");
      setSubmitted(true);
    }

    setIsSubmitting(false);
  };

  const handleGoHome = () => {
    navigate("/", { state: { username } });
  };

  const handleCreateNewRoom = () => {
    navigate("/create-room", { state: { username } });
  };

  const handleEditUserInfo = () => {
    setShowNameForm(true);
  };

  // FIXED: Helper function for info toasts
  const showInfoToast = (message, icon = "ℹ️") => {
    toast(message, {
      icon,
      style: {
        background: "#3498db",
        color: "white",
      },
      duration: 4000,
    });
  };

  return (
    <div className="thank-you-container">
      {/* Add Toaster component for displaying toasts */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 4000,
            style: {
              background: "#10B981",
            },
          },
          error: {
            duration: 4000,
            style: {
              background: "#EF4444",
            },
          },
        }}
      />

      {/* Confetti Effect */}
      {confettiActive && (
        <div className="confetti-container">
          {[...Array(50)].map((_, i) => (
            <div key={i} className="confetti" />
          ))}
        </div>
      )}

      {/* Cross Button */}
      <button className="close-thankyou-btn" onClick={goToIntroPage}>
        <FontAwesomeIcon icon={faTimesCircle} size="2x" />
      </button>

      <div className={`thank-you-card`}>
        {/* Header */}
        <div className="thank-you-header">
          <div className="header-glow"></div>
          <div className="success-icon">
            <FontAwesomeIcon icon={faSmile} size="3x" className="pulse" />
          </div>
          <h1 className="gradient-text">Thank You, {username}! 🚀</h1>
          <p className="subtitle">
            You've successfully left room{" "}
            <span className="highlight">{roomId}</span>
          </p>
          <p className="message">
            <FontAwesomeIcon icon={faHeart} className="heart-beat" />
            Your feedback helps us improve V Editor for everyone.
          </p>
        </div>

        {/* User Info Badge (if registered) */}
        {isRegistered && !showNameForm && !submitted && (
          <div className="user-info-badge slide-in">
            <div className="user-info-content">
              <div className="user-avatar pulse">
                {userRealName.charAt(0).toUpperCase()}
              </div>
              <div className="user-details">
                <h4>{userRealName}</h4>
                <p>
                  {userPosition && `${userPosition} • `}
                  {userEmail || "No email provided"}
                </p>
              </div>
            </div>
            <button
              className="change-user-btn glow-btn"
              onClick={handleEditUserInfo}
            >
              <FontAwesomeIcon icon={faEdit} /> Edit
            </button>
          </div>
        )}

        {/* Privacy Policy Section */}
        {!privacyAccepted && !showNameForm && !submitted && (
          <div className="privacy-policy-section slide-in">
            <div className="privacy-header">
              <FontAwesomeIcon icon={faShield} className="privacy-icon" />
              <h3>Privacy & Data Protection</h3>
            </div>
            <div className="privacy-content">
              <p>
                <strong>
                  Before you continue, please review our privacy policy:
                </strong>
              </p>
              <div className="privacy-points">
                <p>
                  <FontAwesomeIcon icon={faUserShield} />{" "}
                  <strong>Data Collection:</strong> We collect your name, email
                  (optional), and feedback to improve our service.
                </p>
                <p>
                  <FontAwesomeIcon icon={faDatabase} />{" "}
                  <strong>Data Usage:</strong> Your information is used solely
                  for product improvement and will never be sold to third
                  parties.
                </p>
                <p>
                  <FontAwesomeIcon icon={faLock} />{" "}
                  <strong>Data Security:</strong> We implement industry-standard
                  security measures to protect your data.
                </p>
                <p>
                  <FontAwesomeIcon icon={faInfoCircle} />{" "}
                  <strong>Transparency:</strong> You can request to view or
                  delete your data at any time.
                </p>
              </div>

              <div className="privacy-actions">
                <button
                  className="privacy-accept-btn pulse-btn"
                  onClick={acceptPrivacyPolicy}
                >
                  <FontAwesomeIcon icon={faCheck} /> I Accept Privacy Policy
                </button>
                <button
                  className="privacy-view-btn"
                  onClick={() => setShowPrivacyPolicy(!showPrivacyPolicy)}
                >
                  <FontAwesomeIcon icon={faFileContract} />{" "}
                  {showPrivacyPolicy ? "Hide Details" : "View Full Policy"}
                </button>
              </div>

              {showPrivacyPolicy && (
                <div className="privacy-full-policy">
                  <h4>
                    <FontAwesomeIcon icon={faPrivacyLock} /> Full Privacy Policy
                  </h4>
                  <div className="policy-content">
                    <h5>1. Information We Collect</h5>
                    <p>
                      When you use V Editor and provide feedback, we may
                      collect:
                    </p>
                    <ul>
                      <li>Your name (if provided)</li>
                      <li>Email address (optional)</li>
                      <li>Professional position/role</li>
                      <li>Feedback content and ratings</li>
                      <li>Session information and usage data</li>
                    </ul>

                    <h5>2. How We Use Your Information</h5>
                    <p>We use the collected information to:</p>
                    <ul>
                      <li>Improve V Editor features and user experience</li>
                      <li>Analyze user feedback for product development</li>
                      <li>Respond to user inquiries (if email provided)</li>
                      <li>Maintain service security and prevent abuse</li>
                    </ul>

                    <h5>3. Data Storage and Security</h5>
                    <p>Your data is stored securely and:</p>
                    <ul>
                      <li>Is encrypted during transmission</li>
                      <li>Is stored on secure servers</li>
                      <li>Is accessible only to authorized personnel</li>
                      <li>Is retained only as long as necessary</li>
                    </ul>

                    <h5>4. Your Rights</h5>
                    <p>You have the right to:</p>
                    <ul>
                      <li>Access your personal data</li>
                      <li>Request correction of inaccurate data</li>
                      <li>Request deletion of your data</li>
                      <li>Withdraw consent at any time</li>
                      <li>Submit complaints to data protection authorities</li>
                    </ul>

                    <h5>5. Contact Information</h5>
                    <p>
                      For privacy-related inquiries, contact:{" "}
                      <strong>privacy@veditor.com</strong>
                    </p>

                    <div className="policy-footer">
                      <p>
                        <em>Last updated: {new Date().toLocaleDateString()}</em>
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Name Registration Form */}
        {showNameForm && !submitted && (
          <div className="name-form-section slide-in">
            <div className="form-header">
              <h3>
                <FontAwesomeIcon icon={faUser} /> Tell Us About Yourself
              </h3>
              <p>We'd love to know who's giving us feedback! ✨</p>
            </div>

            <div className="name-form-fields">
              <div className="form-group">
                <label>
                  <FontAwesomeIcon icon={faUser} /> Your Full Name *
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  value={userRealName}
                  onChange={(e) => setUserRealName(e.target.value)}
                  required
                  autoFocus
                  className="glow-input"
                />
              </div>

              <div className="form-group">
                <label>
                  <FontAwesomeIcon icon={faBriefcase} /> Your Position / Role
                </label>
                <select
                  value={userPosition}
                  onChange={(e) => setUserPosition(e.target.value)}
                  className="glow-select"
                >
                  <option value="">Select your role</option>
                  <option value="Student">Student</option>
                  <option value="Developer">Developer</option>
                  <option value="Software Engineer">Software Engineer</option>
                  <option value="Web Developer">Web Developer</option>
                  <option value="Full Stack Developer">
                    Full Stack Developer
                  </option>
                  <option value="Manager">Manager</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Researcher">Researcher</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>
                  <FontAwesomeIcon icon={faEnvelope} /> Email Address (Optional)
                </label>
                <input
                  type="email"
                  placeholder="your.email@example.com"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  className="glow-input"
                />
                <small>We'll only use this to follow up if needed</small>
              </div>

              <div className="privacy-checkbox">
                <input
                  type="checkbox"
                  id="privacy-check"
                  checked={privacyAccepted}
onChange={(e) => {
  setPrivacyAccepted(e.target.checked);
  localStorage.setItem("veditor_privacy_accepted", e.target.checked);
}}                  className="glow-checkbox"
                />
                <label htmlFor="privacy-check">
                  <FontAwesomeIcon icon={faShield} /> I have read and accept the{" "}
                  <button
                    type="button"
                    className="privacy-link"
                    onClick={() => setShowPrivacyPolicy(true)}
                  >
                    Privacy Policy
                  </button>
                </label>
              </div>

              <div className="form-actions">
                <button
                  className="submit-name-btn pulse-btn"
                  onClick={registerUser}
                  disabled={!userRealName.trim() || !privacyAccepted}
                >
                  <FontAwesomeIcon icon={faCheck} /> Continue
                </button>
                <button
                  className="skip-btn"
                  onClick={() => {
                    setShowNameForm(false);
                    // FIXED: Use the helper function or custom toast
                    toast("You can submit anonymously", {
                      icon: "👤",
                      style: {
                        background: "#667eea",
                        color: "white",
                      },
                    });
                  }}
                >
                  Skip for Now
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Feedback Form */}
        {!submitted && !showNameForm && privacyAccepted && (
          <form
            className="feedback-form slide-in"
            onSubmit={handleSubmitFeedback}
          >
            {/* Rating */}
            <div className="form-section">
              <label className="form-label">
                <FontAwesomeIcon icon={faStar} /> How would you rate your
                experience?
              </label>
              <div className="rating-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    className={`star-btn ${star <= rating ? "active" : ""} hover-scale`}
                    onClick={() => {
                      setRating(star);
                      setAnimateStars(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faStar} />
                  </button>
                ))}
                <span className="rating-text">
                  {rating === 0 ? "Select stars" : `${rating}/5 stars`}
                </span>
              </div>
            </div>

            {/* Emotion */}
            <div className="form-section">
              <label className="form-label">
                How did you feel about the editor?
              </label>
              <div className="emotion-buttons">
                <button
                  type="button"
                  className={`emotion-btn ${emotion === "happy" ? "active" : ""} hover-scale`}
                  onClick={() => setEmotion("happy")}
                >
                  <FontAwesomeIcon icon={faSmile} size="2x" />
                  <span>Happy</span>
                </button>
                <button
                  type="button"
                  className={`emotion-btn ${emotion === "neutral" ? "active" : ""} hover-scale`}
                  onClick={() => setEmotion("neutral")}
                >
                  <FontAwesomeIcon icon={faMeh} size="2x" />
                  <span>Neutral</span>
                </button>
                <button
                  type="button"
                  className={`emotion-btn ${emotion === "sad" ? "active" : ""} hover-scale`}
                  onClick={() => setEmotion("sad")}
                >
                  <FontAwesomeIcon icon={faFrown} size="2x" />
                  <span>Could be better</span>
                </button>
              </div>
            </div>

            {/* Feedback Text */}
            <div className="form-section">
              <label className="form-label">
                Share your thoughts (optional)
              </label>
              <textarea
                className="feedback-textarea glow-input"
                placeholder="What did you like? What could be improved? Any features you'd love to see?"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                rows="4"
              />
            </div>

            {/* Privacy Note */}
            <div className="privacy-note">
              <p>
                <FontAwesomeIcon icon={faShield} />{" "}
                <strong>Privacy Assurance:</strong>
                Your feedback is protected under our Privacy Policy. We value
                your trust and handle your data with care.
              </p>
            </div>

            {/* Submit Button */}
            <div className="form-actions">
              <button
                type="submit"
                className="submit-btn pulse-btn"
                disabled={isSubmitting || rating === 0}
              >
                {isSubmitting ? (
                  <>
                    <FontAwesomeIcon icon={faMagic} spin />
                    Submitting...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faPaperPlane} />
                    Submit Feedback
                  </>
                )}
              </button>

              {!isRegistered && (
                <div className="anonymous-note">
                  <small>
                    <FontAwesomeIcon icon={faShieldAlt} />
                    Your feedback will be submitted anonymously
                  </small>
                </div>
              )}
            </div>
          </form>
        )}

        {/* Success Message */}
        {submitted && (
          <div className="success-message slide-in">
            <div className="success-glow"></div>
            <div className="success-icon-large">
              <FontAwesomeIcon icon={faGift} className="gift-float" />
            </div>
            <h2 className="gradient-text">Feedback Submitted! 🎉</h2>
            <p className="success-text">
              Your feedback is invaluable to us. We'll use it to make V Editor
              even better!
            </p>

            {userRealName && (
              <div className="personal-thanks">
                <div className="thanks-avatar pulse">
                  {userRealName.charAt(0).toUpperCase()}
                </div>
                <p>
                  <strong>Thank you, {userRealName}!</strong>
                  {userPosition && ` (${userPosition})`}
                </p>
              </div>
            )}

            <div className="privacy-success-note">
              <p>
                <FontAwesomeIcon icon={faShield} />{" "}
                <strong>Data Protection:</strong>
                Your information is protected under our Privacy Policy. You can
                request data deletion at any time.
              </p>
            </div>

            <div className="thank-you-actions">
              <button
                className="action-btn primary pulse-btn"
                onClick={handleGoHome}
              >
                <FontAwesomeIcon icon={faHome} /> Back to Home
              </button>
              <button
                className="action-btn secondary"
                onClick={handleCreateNewRoom}
              >
                <FontAwesomeIcon icon={faCode} /> Create New Room
              </button>
              <button
                className="action-btn tertiary glow-btn"
                onClick={goToIntroPage}
              >
                <FontAwesomeIcon icon={faRocket} /> Explore Intro
              </button>
            </div>
          </div>
        )}

        {/* Footer with Privacy Link */}
        <div className="thank-you-footer">
          <p>
            <button
              className="footer-privacy-link"
              onClick={() => navigate("/privacy")}
            >
              <FontAwesomeIcon icon={faPrivacyLock} /> Privacy Policy
            </button>
            • © {new Date().getFullYear()} V Editor • All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
